{/* This is actually the dinner menu */}

const food = [
    {
        id:1,
        name: 'A Set',
        price: '¥750'
    },
    {
        id:2,
        name: 'B Set',
        price: '¥850'
    },
    {
        id:3,
        name: 'Cheese Nan Set',
        price: '¥950'
    },
    {
        id:4,
        name: 'Butter Chicken Set',
        price: '¥900'
    },
    {
        id:5,
        name: 'Keema Curry Set',
        price: '¥900'
    }
];

export default food;